<template>
  <div class="opacity-0">
    <pre>{{ data }}</pre>
  </div>
</template>

<script setup lang="ts">
import { toHead } from 'vue-datocms'
import { useAppStore } from '~/stores/AppStore'
import { ModelApiKey } from '~/types/models'
import type { StringMultiLocaleField, BooleanTypeMultiLocaleField } from '~/types/generated'

const { locale, t } = useI18n()
const route = useRoute()
const store = useAppStore()
const router = useRouter()
const { throwError } = useNuxtError()
const config = useRuntimeConfig()

const { data, error } = await useAsyncGql('shopCategory', {
  locale,
  slug: route.params.category as string,
  options: {
    initialCache: false
  }
})

if (!data?.value!.shopCategory || error.value) {
  throwError(404)
}

if (data?.value!.shopCategory) {
  route.meta.nuxtI18n = useLocaleSlugs(
    data.value.shopCategory._allSlugLocales as StringMultiLocaleField[],
    data.value.shopCategory._allPublishTranslationLocales as BooleanTypeMultiLocaleField[]
  )
}

const datoHead = toHead((data.value as any).shopCategory.seo)
const i18nHeadLinks = useLocaleHeadLinks(ModelApiKey.ShopCategory)

useHead(() => {
  const metaTags = [...(datoHead.meta || [])]

  // Check for noindex
  if ((data.value as any).shopCategory.noIndex) {
    metaTags.push({ name: 'robots', hid: 'robots', content: 'noindex' })
  }

  return {
    title: datoHead.title,
    link: [...i18nHeadLinks],
    meta: [
      {
        hid: 'og:url',
        property: 'og:url',
        content: config.public.appUrl + route.fullPath
      },
      ...metaTags
    ]
  }
})

onBeforeMount(() => {
  router.replace({ path: t('shop.route'), query: { category: data.value?.shopCategory!.title } })
})

onMounted(() => {
  store.setTheme('white')
})
</script>
